"use client";

import { useFadeInOnReady } from "@/hooks/use-game-player-ready-fade";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface GamePlayerFadeInProps {
  className?: string;
  children: ReactNode;
}

/** Fades in player content on mount (e.g. after URL resolve completes). */
export function GamePlayerFadeIn({ className, children }: GamePlayerFadeInProps) {
  const { fadeClassName, fadeStyle } = useFadeInOnReady(true);

  return (
    <div className={cn("h-full w-full", fadeClassName, className)} style={fadeStyle}>
      {children}
    </div>
  );
}
